@if (showUpdateNotification()) {
  <div class="update-notification">
    <div class="update-content">
      <div class="update-icon"><i class="ph ph-arrows-clockwise" aria-hidden="true"></i></div>
      <div class="update-text">
        <h4>
          {{ 'update_available' | translate }}
          @if (countdown() > 0) {
            <span class="countdown">({{ countdown() }}s)</span>
          }
        </h4>
        <p>{{ 'update_description' | translate }}</p>
      </div>
      <div class="update-actions">
        <p-button [label]="'update_now' | translate" (onClick)="updateNow()" />
        <p-button [label]="'later' | translate" severity="secondary" (onClick)="dismissNotification()" />
      </div>
    </div>
  </div>
}
